'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _loggerLogger = require('../logger/Logger');

var _loggerLogger2 = _interopRequireDefault(_loggerLogger);

var jquery = undefined;

try {
    jquery = window.jQuery;
} catch (e) {
    _loggerLogger2['default'].getLogger().error('JQuery not found');
    jquery = {};
}

exports['default'] = jquery;
module.exports = exports['default'];
//# sourceMappingURL=jquery.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/external/jquery.js
// module id = 200
// module chunks = 0